export default __webpack_public_path__ + "static/media/gaslini.b013be13.png";